import { IAuthService } from '@adminprodigydesign/axis';
import { Injectable } from '@angular/core';
import { catchError, mergeMap, Observable, of, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export interface ActivationPayload {
  action: string;
  email: string;
  otc: string;
  password?: string;
}

export interface ActivationResponse {
  status: 'success' | 'failed';
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService implements IAuthService {
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  async getUser() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    return {
      name: user.name || 'Owner',
      email: user.email || '',
      clientName: user.clientName || 'My Restaurant',
    };
  }

  logout(): void {
    this.http
      .post<any>(
        environment.apiBaseUrl,
        { action: 'logout' },
        { withCredentials: true },
      )
      .pipe(
        tap(() => {
          localStorage.removeItem('user');
          sessionStorage.removeItem('returnUrl');
          this.router.navigate(['/login']);
        }),
        catchError((error) => {
          console.error('logout error:', error);
          localStorage.removeItem('user');
          sessionStorage.removeItem('returnUrl');
          this.router.navigate(['/login']);
          return of(null);
        }),
      )
      .subscribe();
  }

  /**
   * Activates a new user and sets their password.
   * Throws an error with backend message if activation fails.
   */
  activateNewUserWithPassword(
    action: 'validNewUserWithPass',
    email: string,
    otc: string,
    password: string,
  ): Observable<void> {
    const payload: ActivationPayload = { action, email, otc, password };
    return this.http
      .post<ActivationResponse>(environment.apiBaseUrl, payload)
      .pipe(
        mergeMap((res) => {
          if (res.status === 'failed') {
            return throwError(
              () => new Error(res.message || 'Activation failed'),
            );
          }
          return of(undefined);
        }),
      );
  }

  /**
   * Activates a new user (password already set).
   * Throws an error with backend message if activation fails.
   */
  activateNewUser(
    action: 'validNewUser',
    email: string,
    otc: string,
  ): Observable<void> {
    const payload: ActivationPayload = { action, email, otc };
    return this.http
      .post<ActivationResponse>(environment.apiBaseUrl, payload)
      .pipe(
        mergeMap((res) => {
          if (res.status === 'failed') {
            return throwError(
              () => new Error(res.message || 'Activation failed'),
            );
          }
          return of(undefined);
        }),
      );
  }
}
